import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { pinia } from '@/main';

import i18n from '@/plugins/vue-i18n';
import PageName from '@/router/PageName';
import { ErrorHandleStore } from '@/store/ErrorHandleStore';
import Entrance from '@/views/Entrance.vue';
import Top from '@/views/Top.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    // ネイティブアプリのログアウト挙動をトリガー → アラーム全解除
    path: '/first-access',
    name: PageName.TOP,
    component: Top,
  },
  {
    // あらゆるパスを捕まえた後に/first-accessに誘導 ↑
    //
    // redirectを使うのが正当なやり方だが、アラーム通知経由でアプリを起動した場合に
    // ログアウト挙動がトリガーされなかったのでワンクッション入れることにした。
    path: '*',
    name: 'Entrance',
    component: Entrance,
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.onError((error: Error) => {
  // Webpackのコード分割機能の遅延ロードによるLoadingChunkFailed系のエラーの場合はreloadをかける
  if (/Loading chunk [\d]+ failed/.test(error.message)) {
    window.location.reload();
    return;
  }

  //遷移後の画面が取得できない場合

  if (window?.android?.notifyOffline) {
    // Androidのオフライン通知メソッドが存在したら呼び出し
    window.android.notifyOffline();
  } else if (window?.webkit?.messageHandlers?.notifyOffline?.postMessage) {
    // iOSのオフライン通知メソッドが存在したら呼び出し
    window.webkit.messageHandlers.notifyOffline.postMessage('');
  } else {
    // 上記以外の場合はフロントエンドでダイアログ表示
    ErrorHandleStore(pinia).isExistException = true;
  }

  ErrorHandleStore(pinia).exceptionMessage = i18n
    .t('ErrorHandle.Message.Network')
    .toString();
});

export default router;
